const subscription = {
    limit_exceeded: "Vous avez atteint la limite de votre plan d'abonnement.",
    get_plan_failed: "Échec de l'obtention du plan d'abonnement pour le locataire.",
    tenant_suspended: 'Le locataire est suspendu. Veuillez contacter votre administrateur.',
};
export default Object.freeze(subscription);
